export const Colors = {
  orange: "orange",
  green: "green",
  blue: "blue",
  gray: "gray",
  black: "black",
  verizonGreen: "#008331",
  verizonBlack: "#000000",
  verizonWhite: "#ffffff",
  verizonGray: "#d8dada",
  verizonBeige: "#F8F3E9",
  statusGray: "#716F6D",
  statusGreen: "#008331",
  statusRed: "#E10014",
  statusOrange: "#B95319",
  statusDarkGreen: "#145A2E",
};

export const FontFamily = {
  primary: "Verizon-NHG-eDS",
};
